import React from "react";
import Select, { transformDataToSelectOption, SelectProps } from "@/components/atoms/Select";
import { useTranslation } from "react-i18next";
import { INVITABLE_ROLE_TYPES } from "@/utils/roles";

const SelectRoleTypeType: React.FC<SelectProps> = (props) => {
  const { t } = useTranslation();

  const options = INVITABLE_ROLE_TYPES;

  return (
    <Select
      data={transformDataToSelectOption(options, "", "", t, "enumerables:userRoles")}
      loading={false}
      {...props}
    />
  );
};

export default SelectRoleTypeType;
